import { FC } from 'react';
import { TripType } from '../../services/tripType';
import { TripTypeButton } from '../TripTypeButton';
import styles from './TripTypeSelector.module.css';

interface TTripTypeSelectorProps {
  tripType: TripType;
  onChange: (tripType: TripType) => void;
}

export const TripTypeSelector: FC<TTripTypeSelectorProps> = ({
  tripType,
  onChange,
}) => {
  return (
    <div className={styles.toggleGroup}>
      <TripTypeButton
        tripType="BUSINESS"
        active={tripType === 'BUSINESS'}
        onClick={onChange}
      />
      <TripTypeButton
        tripType="WORK"
        active={tripType === 'WORK'}
        onClick={onChange}
      />
      <TripTypeButton
        tripType="PRIVATE"
        active={tripType === 'PRIVATE'}
        onClick={onChange}
      />
      <TripTypeButton
        tripType="NONE"
        active={tripType === 'NONE'}
        onClick={onChange}
      />
    </div>
  );
};
